import SubmitButtonMapText from "../en/submit-button-text.js";
export default SubmitButtonMapText;